import { ParamsData } from '../app';

export default () => {

  
};
